module.exports = __webpack_public_path__ + "img/game-of-sultans.b2ceb01.jpg";